<template>
  <div>
    <el-col :span="4">
      <JxcstoreListView ref="external" :canMultySelect="canMultySelect" @select="bindSelect"></JxcstoreListView>
    </el-col>
    <el-col :span="20">
      <el-main>
        <comment :is="currentcomponent" :cangkucodes="cangkucodes" :cangkuname="cangkuname" :roletype="roletype"
                 v-if="visible"></comment>
      </el-main>

    </el-col>

  </div>

</template>
<script>
  import JxcstoreListView from './JxcstoreListView';
  import AllocationNew from "@/components/warehouse/AllocationListNew"
  import MakeInventory from "@/components/warehouse/MakeInventory"

  export default {
    name: "WarehouseIndexNew",
    data() {
      return {
        activeIndex: 'Storage',
        searchContentHeight: 50,
        cangkucode: "",
        cangkuname: "",
        cangkucodes: "",
        currentcomponent: '',
        visible: false,
        brokenparts: 1,
        status: this.mystatus,
      };
    },
    props: {
      mystatus: {
        default: ''
      },
      roletype: {
        default: ''
      },
      canMultySelect: {
        default: true
      }
    },
    methods: {
      // handleSelect(key, keyPath) {
      //   this.isAlive = false
      //   this.$nextTick(() => {
      //     this.$router.push({name: key, query: {cangkucodes: this.cangkucodes, cangkuname: this.cangkuname}})
      //     this.isAlive = true
      //   })
      // },
      bindSelect(cangkucodes, cangkuname, unitguid) {
        this.cangkucodes = cangkucodes
        this.cangkuname = cangkuname
        this.visible = false
        this.$nextTick(() => {
          this.visible = true
        })
      }
    },
    computed: {
      // showcangkuname() {
      //   if (this.cangkucodes.length == 1) {
      //     return this.cangkuname
      //   }
      // }
    },

    mounted() {
      if (this.status == "allocation") {
        this.currentcomponent = 'AllocationNew'
      } else if (this.status == "makeinventory") {
        this.currentcomponent = 'MakeInventory'
      }
    },
    components: {
      JxcstoreListView,
      AllocationNew,
      MakeInventory,
    }
  }


</script>
<style scoped>
  .bg-img {
    /*//position: absolute;*/
    z-index: -1;
    width: 100%;
    height: calc(100vh - 55px);
  }

  .el-main {
    padding: 0px;
    height: calc(100vh - 97px);
    width: 100%;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/WarehouseIndexNew.vue